module.exports = __webpack_public_path__ + "static/media/img-ami-1.f14a24de.png";